import axiosApi, { setHeader } from "api/root.api";

export const getObjectInfo = async (uuid) => {
  const urlEnd = `/scan/publish/v1/product/object/${uuid}`;
  const response = await axiosApi.get(urlEnd);
  const result = response.data;
  return result;
};
